import request from '@/utils/request'

/**
 * 获取产品参数页面所有公开数据
 */
export function getPublicSpecsList() {
  return request({
    url: '/cms/specs/public/list',
    method: 'get'
  })
}
